export default __webpack_public_path__ + "static/media/adroll.9ea2f861.svg";